import Modal from "@material-ui/core/Modal";
import Button from "@mui/material/Button";
import {
  Document,
  PDFDownloadLink,
  PDFViewer,
  Page,
  Text,
  View,
} from "@react-pdf/renderer";
import { useState } from "react";
import InvoiceItemsTable from "./InvoiceItemsTable";
import { GenericInvoiceTitle, VoucherSubTitle } from "./InvoiceTitle";

function Report({ open, handleClose, data }) {
  const [numPages, setNumPages] = useState(null);
  const width = window.innerWidth;
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    console.log(data);
  }
  const style = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="keep-mounted-modal-title"
      aria-describedby="keep-mounted-modal-description"
      style={style}
    >
      {width > 768 ? (
        <PDFViewer Width="800" height="600" className="app">
          <Document onLoadSuccess={onDocumentLoadSuccess}>
            <Page size="A4"  style={{ marginBottom: 0 }}>
              <View fixed>
                <GenericInvoiceTitle
                  titleData={data.titleData}
                  title={data.docTitle}
                  invoiceType={data.docType}
                  from={data.from}
                  to={data.to}
                  codeDetails={data.codeDetails}
                  pageNumber={numPages}
                />
                {data.docType == "Voucher" ? (
                  <VoucherSubTitle
                    subTitleData={data.subTitleData}
                  ></VoucherSubTitle>
                ) : (
                  <></>
                )}
              </View>
              <InvoiceItemsTable
                headerData={data.headerData}
                headerType={data.docType}
                invoice={data.invoice}
                level1Array={data.level1Array}
                invoiceType={data.docType}
                totalDebit={data.totalDebit}
                totalCredit={data.totalCredit}
                balance={data.balance}
                openingBalance={data.openingBalance}
                codeDetails={data.codeDetails}
                level3Array = {data.level3Array}
              />
              {/* <Text
                style={{
                  position: "absolute",
                  bottom: 6,
                  left: 0,
                  right: 0,
                  textAlign: "center",
                  color: "grey",
                  fontSize: 6,
                }}
                render={({ pageNumber, totalPages }) =>
                  "Page " + `${pageNumber} / ${totalPages}`
                }
                fixed
              /> */}
            </Page>
          </Document>
        </PDFViewer>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <PDFDownloadLink
            document={
              <Document onLoadSuccess={onDocumentLoadSuccess}>
                <Page size="A4"  style={{ marginBottom: 0 }}>
                  <View fixed>
                    <GenericInvoiceTitle
                      titleData={data.titleData}
                      title={data.docTitle}
                      invoiceType={data.docType}
                      from={data.from}
                      to={data.to}
                      codeDetails={data.codeDetails}
                      pageNumber={numPages}
                    />
                    {data.docType == "Voucher" ? (
                      <VoucherSubTitle
                        subTitleData={data.subTitleData}
                      ></VoucherSubTitle>
                    ) : (
                      <></>
                    )}
                  </View>
                  <InvoiceItemsTable
                    headerData={data.headerData}
                    headerType={data.docType}
                    invoice={data.invoice}
                    level1Array={data.level1Array}
                    invoiceType={data.docType}
                    totalDebit={data.totalDebit}
                    totalCredit={data.totalCredit}
                    balance={data.balance}
                    openingBalance={data.openingBalance}
                    codeDetails={data.codeDetails}
                    level3Array = {data.level3Array}
                  />
                  {/* <Text
                    style={{
                      position:'relative',
                      bottom: 0,
                      left: 0,
                      right: 0,
                      textAlign: "center",
                      color: "grey",
                      fontSize: 6,
                    }}
                    // render={({ pageNumber, totalPages }) =>
                    //   "Page " + `${pageNumber} / ${totalPages}`
                    // }
                    fixed
                  /> */}
                </Page>
              </Document>
            }
            fileName="Invoice Report Detail.pdf"
          >
            <Button
              variant="contained"
              style={{
                borderWidth: 1,
                borderRadius: 10,
              }}
            >
              Download file
            </Button>
          </PDFDownloadLink>
        </div>
      )}
    </Modal>
  );
}

export default Report;
